import type { PropsWithChildren } from "react"
import { Text } from "@oysterhr/ui"
import { IconWithTooltip } from "@oysterhr/feature-components"

interface Props {
  label: string
  tooltipText?: string
}

export const Row = ({ label, children, tooltipText }: PropsWithChildren<Props>) => (
  <div className="flex flex-col gap-1">
    <Text size="small" className="font-medium">
      {label}
      {tooltipText && (
        <IconWithTooltip icon="InfoCircle" size="xs" value={tooltipText} className="ml-1" />
      )}
    </Text>
    {typeof children === "string" ? (
      <Text size="medium" className="text-gray-400">
        {children}
      </Text>
    ) : (
      children
    )}
  </div>
)
